<header-title [model]="headerTitle"></header-title>

<section class="card mt-4">
    <header class="card-header">
        <h3 class="text-gray-600 m-0"><i class="fas fa-tasks me-2"></i>Update Lender</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <div class="tab-navigation">
                <nav>
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link text-muted" [routerLink]="['/lenders', 'edit', lenderId]">
                                <i class="fas fa-building" aria-hidden="true"></i>Lender Details
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link active text-primary">
                                <i class="fas fa-users" aria-hidden="true"></i>Contact Details
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>

                    <ng-container *ngIf="showContactAddForm">
                        <h4 class="mt-5 text-primary">Add Contact Details</h4>
                        <form (submit)="registerUserToLender()">
                            <div class="row mt-3">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Email
                                        </label>
                                        <input type="email" id="email" name="email" class="form-control" [(ngModel)]="newUser.email" placeholder="newuser@domain.com"
                                               required #email="ngModel" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" (blur)="checkEmail()" />
                                        <div *ngIf="email.errors && (email.dirty || email.touched || submitAttempt)">
                                            <label class="error" [hidden]="!email.errors.required">Email is a required field.</label>
                                            <label class="error" [hidden]="!email.errors.pattern">Not a valid email address.</label>
                                        </div>
                                        <div *ngIf="!isEmailValid">
                                            <label class="error">Email is already in use.</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">
                                            First name
                                        </label>
                                        <input type='text' class="form-control" [(ngModel)]="newUser.firstName" name="firstName" required #firstName="ngModel" />
                                        <div *ngIf="firstName.errors && (firstName.dirty || firstName.touched || submitAttempt)">
                                            <label class="error" [hidden]="!firstName.errors.required">First name is a required field.</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Last name
                                        </label>
                                        <input class="form-control" [(ngModel)]="newUser.lastName" name="lastName" #lastName="ngModel" required />
                                        <div *ngIf="lastName.errors && (lastName.dirty || lastName.touched || submitAttempt)">
                                            <label class="error" [hidden]="!lastName.errors.required">Last name is a required field.</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Phone Number
                                        </label>
                                        <input type='text' class="form-control" [(ngModel)]="newUser.phoneNr" name="phoneNr" #phoneNr="ngModel" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Mobile Number
                                        </label>
                                        <input type='text' class="form-control" [(ngModel)]="newUser.mobileNr" name="mobileNr" #mobileNr="ngModel" />
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Notes
                                        </label>
                                        <textarea class="form-control" [(ngModel)]="newUser.notes" name="notes"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12 text-end">
                                    <button class="btn btn-outline-primary ms-2" type="button" (click)="hideAddUserForm()">Cancel</button>
                                    <button class="btn btn-success ms-2" type="submit">Add Contact</button>
                                </div>
                            </div>
                        </form>
                    </ng-container>
                    <ng-container *ngIf="showContactEditForm">
                        <h3 class="mt-5 text-primary">Edit Contact Details</h3>
                        <form (submit)="updateUserForLender()">
                            <div class="row mt-3">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Email
                                        </label>
                                        <input type="email" id="email" name="email" class="form-control" [(ngModel)]="exUser.email" placeholder="exuser@domain.com"
                                               disabled />

                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">
                                            First name
                                        </label>
                                        <input type='text' class="form-control" [(ngModel)]="exUser.firstName" name="firstName" required #firstName="ngModel" />
                                        <div *ngIf="firstName.errors && (firstName.dirty || firstName.touched || submitAttempt)">
                                            <label class="error" [hidden]="!firstName.errors.required">First name is a required field.</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Last name
                                        </label>
                                        <input class="form-control" [(ngModel)]="exUser.lastName" name="lastName" #lastName="ngModel" required />
                                        <div *ngIf="lastName.errors && (lastName.dirty || lastName.touched || submitAttempt)">
                                            <label class="error" [hidden]="!lastName.errors.required">Last name is a required field.</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Phone Number
                                        </label>
                                        <input type='text' class="form-control" [(ngModel)]="exUser.phoneNr" name="phoneNr" #phoneNr="ngModel" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Mobile Number
                                        </label>
                                        <input type='text' class="form-control" [(ngModel)]="exUser.mobileNr" name="mobileNr" #mobileNr="ngModel" />
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="control-label">
                                            Notes
                                        </label>
                                        <textarea class="form-control" [(ngModel)]="exUser.notes" name="notes"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12 text-end">
                                    <button class="btn btn-outline-primary ms-2" type="button" (click)="cancelEditContact()" *ngIf="!isDeleteMode">Cancel</button>
                                    <button class="btn btn-danger ms-2" type="button" (click)="toggleDeleteMode()" *ngIf="!isDeleteMode">Delete</button>
                                    <button class="btn btn-outline-primary ms-2" type="button" (click)="toggleDeleteMode()" *ngIf="isDeleteMode">Cancel Delete</button>
                                    <button class="btn btn-danger ms-2" type="button" (click)="confirmDeleteContact()" *ngIf="isDeleteMode">Confirm Delete</button>
                                    <button class="btn btn-success ms-2" type="submit" *ngIf="!isDeleteMode">Update</button>
                                </div>
                            </div>
                        </form>
                    </ng-container>
                    <ng-container *ngIf="showContactDetails">
                        <h3 class="mt-5 text-primary">Lender Contact<span *ngIf="lenderContacts.length>1">s</span></h3>
                        <div class="row mt-3">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Name
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Email
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="control-label">
                                        Phone
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="control-label">
                                        Mobile
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="control-label">
                                        &nbsp;
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3" *ngFor="let x of lenderContacts;index as i">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <input type="text" value="{{x.firstName}} {{x.lastName}}" disabled class="form-control">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <input type="text" value="{{x.email}}" disabled class="form-control">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <input type="text" value="{{x.phoneNr}}" disabled class="form-control">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <input type="text" value="{{x.mobileNr}}" disabled class="form-control">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <button class=" form-control btn btn-link ml-1" type="button" (click)="editLenderContact(x.id)"><span class="fas fa-pencil-alt"></span></button>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12 text-end">
                                <button class="btn btn-primary ml-1" type="button" (click)="showAddUserForm()">Add Contact</button>
                            </div>
                        </div>
                    </ng-container>
        </div>
    </div>
</section>
